module.exports = __webpack_public_path__ + "static/media/HDOT-USDT.8a12a8bc.svg";